import { useRegisterSW } from 'virtual:pwa-register/react'
import { useTranslation } from 'react-i18next'
import Collapse from '@mui/material/Collapse'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

const UPDATE_POLL_MS = 30 * 60 * 1000 // 30 minutes

export function PwaUpdatePrompt() {
  const { t } = useTranslation()
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return
      setInterval(() => {
        if (navigator.onLine) registration.update()
      }, UPDATE_POLL_MS)
    },
  })

  return (
    <Collapse in={needRefresh} unmountOnExit>
      <Alert
        severity="warning"
        onClose={(e) => { e.stopPropagation(); setNeedRefresh(false) }}
        onClick={() => updateServiceWorker(true)}
        sx={{
          borderRadius: 0,
          borderBottom: '1px solid',
          borderColor: 'warning.dark',
          px: 3,
          cursor: 'pointer',
          '&:hover': { filter: 'brightness(0.96)' },
        }}
      >
        <AlertTitle sx={{ mb: 0 }}>
          {t('appUpdate.message', 'An updated version is available. Click here to reload.')}
        </AlertTitle>
      </Alert>
    </Collapse>
  )
}
